<template lang="pug">
    div
        //crud-form(
            :fields="fields"
            @autocompleteObjSelectId="selectedDays"
            noButtons
            )
            crud-data-table.mt-5(
                v-if="!loadingData"
                :service="serviceTable" 
                :headers="headerTable" 
                :deleteButton="()=>{true}" 
                noAutoWidth 
                @show="submitShow($event)" 
                slot="appendContent"
                noSearchBox
                :filters="[]"
                )
        model-data-table(
            loading-text="Cargando documentos recientes..."
            no-data-text="Sin documentos recientes."
            no-search
            no-remove
            ref="table"
            v-bind="tableProps"
            @detail="submitShow"
        )
            template( slot='actions' slot-scope='props' )
                r-btn-action( 
                    color='dark'
                    tooltip='PDF'
                    @click='submitPdf(props)' 
                )
                    v-icon picture_as_pdf
            template( slot="prepend" )
                v-flex(xs2)
                    v-select(
                        v-model="daysModel"
                        item-value="days"
                        item-text="text"
                        :items="daysList"
                        )
        detail-dialog(ref="invoiceDetailDialog" :invoiceId="invoiceId" readOnly)
</template>

<script>
//-
import { RBtnAction, ModelDataTable } from '@/components/reusable_components/next'
import SlSaleInvoiceMdl from '@/models/Sale/SlSaleInvoice.js'
import TableHeaders from '@/views/customer/tables/customerRecentInvoice/Headers.js'
import DetailDialog from '@/components/dialogs/invoice/InvoiceDetailDialog'
//-
export default {
    name: 'customer-recent-invoice',
    // props: {},
    data: function() {
        return {
            headerTable: TableHeaders,
            //headerTable: [{ text: '#', value: 'id' }],
            customerId: null,
            invoiceId: '',
            daySelected: 30,
            daysModel: 30,
            filters: [
                {
                    name: 'number',
                    props: {
                        label: 'Folio',
                    },
                    flex: {
                        sm6: true,
                        lg5: true,
                    },
                    type: 'text-field',
                },
            ],
            daysList: [
                { days: 30, text: '30 días' },
                { days: 45, text: '45 días' },
                { days: 60, text: '60 días' },
                { days: 90, text: '90 días' },
                { days: 120, text: '120 días' },
            ],
        }
    },
    computed: {
        tableProps() {
            return {
                service: SlSaleInvoiceMdl,
                paramFilter: {
                    sl_customer_id: this.customerId,
                    recent: this.daySelected,
                },
                headers: this.headerTable,
                filters: this.filters,
            }
        },
    },
    methods: {
        //-
        setCustomerId() {
            this.customerId = this.$route.params.id
        },

        /**
         * @description
         * Print sale invoice PDF
         *
         * @param      {object}  event   The event
         * @return     {object}  blob file
         */
        submitPdf(event) {
            return event.item.toPdf()
        },
        
        /**
         */
        submitShow(event) {
            this.invoiceId = event.item.id
            this.$refs.invoiceDetailDialog.open = true
        },
    },
    watch: {
        daysModel(val) {
            this.daySelected = val
        },
    },
    components: {
        RBtnAction,
        'model-data-table': ModelDataTable,
        'detail-dialog': DetailDialog,
    },
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    beforeMount: function() {
        this.setCustomerId()
    },
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss"></style>
